import { ReactNode } from "react";
import { Box, BoxProps } from "@mui/material";
import styles from "./index.module.css";

type ScreenReaderTextProps = {
	children: ReactNode;
} & BoxProps;

export function ScreenReaderText({ children, ...props }: ScreenReaderTextProps) {
	return (
		<Box className={styles.hiddenText} {...props}>
			{children}
		</Box>
	);
}
